export default "__VITE_ASSET__C1o6nm4$__"